// src/pages/Deposit/components/PaymentMethodSelect.jsx
export default function PaymentMethodSelect({ selected, onChange }) {
    const methods = [
      { id: 'card', name: 'Credit Card', icon: 'credit-card' },
      { id: 'bank', name: 'Bank Transfer', icon: 'building-columns' },
      { id: 'crypto', name: 'Cryptocurrency', icon: 'bitcoin-sign' }
    ];
  
    return (
      <div className="mb-4">
        <label className="block text-zinc-300 mb-2">
          Payment Method
        </label>
        <div className="grid grid-cols-3 gap-3">
          {methods.map((method) => (
            <div
              key={method.id}
              onClick={() => onChange(method.id)}
              className={`flex flex-col items-center justify-center p-3 rounded-md cursor-pointer border transition-all ${
                selected === method.id
                  ? 'border-purple-500 bg-purple-900/20'
                  : 'border-zinc-700 hover:border-zinc-600'
              }`}
            >
              <i className={`fas fa-${method.icon} text-xl mb-2 ${
                selected === method.id ? 'text-purple-400' : 'text-zinc-400'
              }`}></i>
              <span className="text-sm">{method.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  